/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    NEWS SCROLL
\*------------------------------------*/
class NewsScroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;
        self.item = self.elem.querySelector('[data-news-scroll-item]');
        self.trigger = self.elem.querySelector('[data-news-scroll-trigger]');

        self.number = self.elem.querySelector('[data-news-scroll-number]');

        self.content = self.elem.querySelector('[data-news-scroll-content]');
        self.imgs = self.elem.querySelectorAll('[data-news-scroll-img]');
        self.items = self.elem.querySelectorAll('[data-news-scroll-content-item]');
        self.itemLast = self.elem.querySelector('[data-news-scroll-content-item-last]');
        self.start = self.elem.querySelector('[data-news-scroll-start]');
        // self.end = self.elem.querySelector('[data-news-scroll-end]');

        self.element = self.elem.querySelector('[data-stick-scroll-element]');
        self.stickyScrollItem = self.elem.querySelector('[data-stick-scroll-item]');
        self.end = self.elem.querySelector('[data-stick-scroll-end]');
    }

    init() {
        let self = this;

        self.stickyItem();

        if(self.trigger !== null) {
            self.stickyNews();
        }

        window.onresize = function(event) {
            self.stickyItem();
            self.stickyNews();
        };
    }

    stickyNews() {
        let self = this;

        self.stickyScrollItem.style.width = self.element.offsetWidth+'px';

        document.addEventListener('scroll', (e) => {
            self.items.forEach(function (item) {
                if (self.isScrolledIntoView(item) == true) {
                    self.number.innerText = item.dataset.newsScrollContentItemCount;

                    self.imgs.forEach(function (img) {
                        if (img.dataset.newsScrollImgCount === item.dataset.newsScrollContentItemCount) {
                            img.classList.add('is-active');
                        } else {
                            img.classList.remove('is-active');
                        }
                    });
                }
            });
        });
    }

    isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    isScrolled() {
        let self = this;
        const html = document.getElementsByTagName("HTML")[0];

        self.elem.style.height = self.content.offsetHeight+'px';

        document.addEventListener('scroll', (e) => {
            if (window.scrollY > self.elem.offsetTop) {
                self.elem.classList.add('is-fixed');
            } else {
                self.elem.classList.remove('is-fixed');
            }
        });

        const bounding = self.end.getBoundingClientRect();
        const calc = self.item.offsetHeight + top;

        if (calc > bounding.y) {
            self.elem.classList.add('is-fixed');
        } else {
            self.elem.classList.remove('is-fixed');
        }
    }

    stickyItem() {
        let self = this;

        const top = 100;

        document.addEventListener('scroll', (e) => {
            const offsetTop = self.element.getBoundingClientRect().top + document.documentElement.scrollTop - top;

            if (window.scrollY > offsetTop) {
                self.stickyScrollItem.classList.add('is-sticky');
                self.element.classList.add('is-sticky');
            } else {
                self.stickyScrollItem.classList.remove('is-sticky');
                self.element.classList.remove('is-sticky');
            }

            const bounding = self.end.getBoundingClientRect();
            const calc = self.stickyScrollItem.offsetHeight + top;

            if (calc > bounding.y) {
                self.stickyScrollItem.classList.add('is-stuck');
            } else {
                self.stickyScrollItem.classList.remove('is-stuck');
            }
        });
    }
}

export default NewsScroll;
